
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { useTranslation } from 'react-i18next';

const HowToConnectWithBX24 = () => {
    const { t } = useTranslation();

    return (
        <div className="flex relative ">

            <main className="flex-1 px-4 sm:px-6 lg:px-8 py-8">
                <div className="max-w-4xl mx-auto">
                    {/* Header */}
                    <div className="mb-8">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">
                            {t('howToConnectWithBitrix24')}
                        </h1>
                        <p className="text-xl text-gray-600">
                            {t('completeGuideToIntegrate')}
                        </p>
                    </div>


                    {/* Integración con BX24 */}
                    <section  id="integracion" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            {t('integrationWithBX24')}
                        </h2>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('step1AccessDeveloperResources')}
                            </h3>
                            <p className="text-gray-700 ">
                                {t('step1Description')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bx24/1.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bx24/1.png" 
                                    alt="Bitrix24 Dashboard Overview"
                                    className="w-full"
                                />
                            </a>

                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure1MainPanel')}</p>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('step2ConnectWithAPI')}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t('step2Description1')}
                            </p>
                            
                            <p className="text-gray-700">
                                {t('step2Description2')}
                            </p>
                        </Card>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div className="rounded-lg overflow-hidden shadow-lg">
                                <a className="w-full cursor-pointer" href="/img/bx24/2.png" target="_blank" rel="noopener noreferrer">
                                    <img 
                                        src="/img/bx24/2.png" 
                                        alt="Developer resources"
                                        className="w-full"
                                    />
                                </a>
                                <div className="bg-gray-100 px-4 py-2">
                                    <p className="text-sm text-gray-600">{t('figure3DeveloperResources')}</p>
                                </div>
                            </div>
                            <div className="rounded-lg overflow-hidden shadow-lg">
                                <a className="w-full cursor-pointer" href="/img/bx24/3.png" target="_blank" rel="noopener noreferrer">
                                    <img 
                                        src="/img/bx24/3.png" 
                                        alt="Other"
                                        className="w-full"
                                    />
                                </a>
                                <div className="bg-gray-100 px-4 py-2">
                                    <p className="text-sm text-gray-600">{t('figure4Other')}</p>
                                </div>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('step3CreateLocalApplication')}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t('step3Description1')}
                            </p>

                            <p className="text-gray-700 mb-4">
                                {t('step3Description2')}
                            </p>

                            <p className="text-gray-700 mb-4">
                                {t('step3Description3')}
                            </p>

                            <p className="text-gray-700 mb-4">
                                {t('step3Description4')}
                            </p>

                            <p className="text-gray-700 ">
                                {t('step3PermissionsNote')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bx24/4.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bx24/4.png" 
                                    alt="Local Application"
                                    className="w-full"
                                />
                            </a>

                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure5LocalApplication')}</p>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('step4CopyCredentials')}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t('step4Description1')}
                            </p>
                            
                            <p className="text-gray-700">
                                {t('step4Description2')}
                            </p>
                        </Card>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div className="rounded-lg overflow-hidden shadow-lg">
                                <a className="w-full cursor-pointer" href="/img/bx24/5.png" target="_blank" rel="noopener noreferrer">
                                    <img 
                                        src="/img/bx24/5.png" 
                                        alt="Developer resources"
                                        className="w-full"
                                    />
                                </a>
                                <div className="bg-gray-100 px-4 py-2">
                                    <p className="text-sm text-gray-600">{t('figure6Credentials')}</p>
                                </div>
                            </div>
                            <div className="rounded-lg overflow-hidden shadow-lg">
                                <a className="w-full cursor-pointer" href="/img/bx24/6.png" target="_blank" rel="noopener noreferrer">
                                    <img 
                                        src="/img/bx24/6.png" 
                                        alt="Other"
                                        className="w-full"
                                    />
                                </a>
                                <div className="bg-gray-100 px-4 py-2">
                                    <p className="text-sm text-gray-600">{t('figure7Integration')}</p>
                                </div>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('step5ConnectChannel')}
                            </h3>
                            <p className="text-gray-700 ">
                                {t('step5Description')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bx24/7.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bx24/7.png" 
                                    alt="Bitrix24 Dashboard Overview"
                                    className="w-full"
                                />
                            </a>

                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure8OpenChannels')}</p>
                            </div>
                        </div>
                    </section>

                    {/* Configuración */}
                    <section  id="configuracion" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            {t('integration')}
                        </h2>
                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('videoTutorialBasicSetup')}
                            </h3>
                            <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center mb-4">
                                <video
                                    controls        // play / pause / volumen
                                    muted
                                    src='/video/tutorial.mp4'
                                    playsInline
                                />

                            </div>
                        </Card>
                    </section>


                    {/* Solución de Problemas */}
                    {/* <section  id="problemas" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            Solución de Problemas
                        </h2>
                        <div className="space-y-4 mb-6">
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    Error: "Connection refused"
                                </h3>
                                <p className="text-gray-700">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Verifica que:
                                </p>
                                <ul className="list-disc list-inside ml-4 mt-2 text-gray-700">
                                    <li>Sed do eiusmod tempor incididunt</li>
                                    <li>Ut enim ad minim veniam</li>
                                    <li>Duis aute irure dolor</li>
                                </ul>
                            </Card>
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    Error: "Invalid credentials"
                                </h3>
                                <p className="text-gray-700">
                                    Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </p>
                            </Card>
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    Error: "Rate limit exceeded"
                                </h3>
                                <p className="text-gray-700">
                                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                </p>
                            </Card>
                        </div>
                    </section> */}

                    {/* FAQ */}
                    {/* <section  id="faq" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            Preguntas Frecuentes
                        </h2>
                        <div className="space-y-4 mb-6">
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    ¿Lorem ipsum dolor sit amet?
                                </h3>
                                <p className="text-gray-700">
                                    Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                                </p>
                            </Card>
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    ¿Sed do eiusmod tempor incididunt?
                                </h3>
                                <p className="text-gray-700">
                                    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.
                                </p>
                            </Card>
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    ¿Ut enim ad minim veniam?
                                </h3>
                                <p className="text-gray-700">
                                    Sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                </p>
                            </Card>
                            <Card>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    ¿Quis nostrud exercitation ullamco?
                                </h3>
                                <p className="text-gray-700">
                                    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae ultricies.
                                </p>
                            </Card>
                        </div>

                    </section> */}

                    <Card className="mb-6">
                        <h3 className="text-xl font-semibold text-gray-800 mb-3">
                            {t('nextStepsInstallAIChatbot')}
                        </h3>
                        <p className="text-gray-700 ">
                            {t('expandIntegrationWithAI')} <Link to="/ai-chatbot-documentation" className="text-blue-600 hover:underline">{t('howToInstallAIChatbot')}</Link>
                        </p>
                    </Card>

                    <Card className="bg-blue-50 border-2 border-blue-200">
                        <div className="flex items-start">
                            <svg className="w-6 h-6 text-blue-600 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                            <div>
                                <h3 className="text-lg font-semibold text-blue-900 mb-2">
                                    {t('needMoreHelp')}
                                </h3>
                                <p className="text-blue-800">
                                    {t('contactSupportTeam')}
                                </p>
                            </div>
                        </div>
                    </Card>

                    {/* Footer */}
                    <div className="mt-12 pt-8 border-t border-gray-200">
                        <p className="text-center text-gray-500 text-sm">
                            {t('lastUpdated')}
                        </p>
                    </div>
                </div>
            </main>
        </div>
    );
}
 
export default HowToConnectWithBX24;